const TipsSuksesCoding: React.FC = () => {
    return (
        <div className="text-justify py-4">
            <h2 className="text-lg font-semibold mb-3">🏁 5 Tips Sukses Mengikuti Lomba Coding untuk Pemula</h2>
            <p className="mb-4">
                Baru pertama kali ikut lomba coding? Tenang, semua orang pernah jadi pemula! Berikut ini 5 tips penting biar kamu gak cuma ikut, tapi juga siap bersaing dengan percaya diri 💪
            </p>

            <ul className="list-disc list-inside space-y-2 mb-4">
                <li>
                    <strong>🔍 Pahami aturan lomba dengan saksama</strong>
                    <p>Jangan sampai kamu kalah bukan karena salah koding, tapi karena gak baca peraturan! Cek format input/output, bahasa yang boleh dipakai, dan sistem penilaiannya.</p>
                </li>
                <li>
                    <strong>🧠 Latih diri dengan soal-soal serupa</strong>
                    <p>Cari soal-soal dari lomba tahun-tahun sebelumnya atau platform seperti LeetCode, Codeforces, dan AtCoder. Semakin sering latihan, makin tajam insting ngodingmu!</p> 
                </li>
                <li>
                    <strong>⏱️ Kelola waktu dengan baik saat kompetisi</strong> 
                    <p>Jangan terlalu lama di satu soal. Prioritaskan soal yang kamu yakin bisa dulu. Manajemen waktu itu kunci!</p>
                </li>
                <li>
                    <strong>💻 Pelajari bahasa pemrograman yang sesuai</strong>
                    <p>Umumnya, C++, Java, dan Python adalah bahasa favorit lomba. Pilih yang paling kamu kuasai dan pastikan kamu tahu sintaks dasar & library pentingnya.</p>
                </li>
                <li>
                    <strong>💡 Jangan takut salah, terus belajar dari setiap kegagalan</strong>
                    <p>Salah jawab? Timeout? Compile error? Itu hal biasa. Justru dari kegagalan-kegagalan itu kamu bakal makin jago.</p>
                </li>
            </ul>

            <p className="text-gray-700">
                Lomba coding bukan soal jadi yang paling jenius, tapi soal siapa yang paling siap dan konsisten belajar. Siap menantang diri kamu? 🚀
            </p>
        </div>
    )
}
export default TipsSuksesCoding